'use strict';

angular.module('mean.admin-panel').controller('BuilderAdminCompanyController', ['$scope', 'Users', 'Global', 'MeanUser', '$filter', 'toaster', '$q', 'AdminPanel', 'Contractors', 'Builders', 'userService',
  function($scope, Users, Global, MeanUser, $filter, toaster, $q, AdminPanel, Contractors, Builders, userService) {
    $scope.global = Global;
    $scope.package = {
      name: 'admin-panel'
    };

    $scope.user = MeanUser.user;
    var array = MeanUser.user.username.split('', 9);

    $scope.mtc_code = array[2] + array[3] + array[4];

    for(var i=0; i<$scope.user.roles.length; i++) {
        if ($scope.user.roles[i] === 'builder_admin') {
            $scope.builder_admin = true;
        }
    }

    //$scope.builder_users =
    userService.getUsers($scope.user.trade[0], $scope.mtc_code).then(function(success) {
        $scope.division_users = $scope.builder_users = success;
    }, function(error) {
        toaster.pop('error', 'Company Admin Panel', 'Could not access users from the database.');
    });

    if(!$scope.builder_admin) {
        toaster.pop('error', 'Company Admin Panel', 'You do not have the proper permissions for this page.');
        return;
    }

    Builders.query({'builder': $scope.user._id}, function(builders) {
        if(builders.length === 1) {
            $scope.selectedBuilder = builders[0];
        } else if(builders.length === 0) {
            toaster.pop('error', 'Admin Panel', 'No Builder information in the database. Contact Admin.');
            return;
            //$scope.addBuilder();
        } else {
            toaster.pop('error', 'Admin Panel', 'Too many Builder database entries. Contact Admin.');
            return;
        }
    })

    // Contractors.query({'code': $scope.mtc_code},function(contractors) {
    //     if(contractors.length === 1) {
    //         $scope.selectedItem = contractors[0];
    //     } else if(contractors.length === 0) {
    //         toaster.pop('warning', 'Admin Panel', 'No Company information in the database. Adding now.');
    //         $scope.addContractor();
    //     } else {
    //         toaster.pop('error', 'Admin Panel', 'Too many Company database entries. Contact Admin.');
    //         return;
    //     }
    // });

    $scope.menu = ['Builder', 'Project Manager'];
    $scope.current_menu = 'Builder';

    $scope.onSelect = function(s) {
        $scope.current_menu = s;
    };

    $scope.update = function() {
        if(!$scope.codeError) {
           $scope.selectedItem.$update(function(response) {
                toaster.pop('success', 'Company Admin Panel', 'Contractor database has been updated');
            }, function(error) {
                toaster.pop('error', 'Company Admin Panel', error);
            });
        } else {
            alert('Could not save due to contractor code error');
        }
    };

    $scope.updateUser = function(index, user) {
        $scope.selectedItem.division[index].name = user.name;
        $scope.selectedItem.division[index].phone = user.phone;
        $scope.selectedItem.division[index].email = user.email;
        $scope.selectedItem.division[index].mtc_id = user._id;
    };

    // $scope.addContractor = function(){
    //     var divs = []

    //     for(var i=1; i<13; i++) {
    //         if(i < 10) {
    //             divs.push({
    //                 code: '0' + i
    //             });
    //         } else {
    //             divs.push({
    //                 code: i
    //             });
    //         }
    //     }

    //     $scope.codeError = true;

    //     var contractor = new Contractors({
    //         code: $scope.mtc_code,
    //         division: divs
    //     });

    //     contractor.$save(function(response) {
    //         toaster.pop('success', 'Admin Panel', 'Contractor database updated');

    //         $scope.selectedItem = response;
    //     }, function(error) {
    //         toaster.pop('error', 'Admin Panel', error.data);
    //     });
    // };

    // $scope.addBuilder = function(){
    //     var builder = new Builders({
    //         builder: $scope.user._id,
    //         company_code: userService.getCompanyCode($scope.user.username)
    //     });

    //     builder.$save(function(response) {
    //         toaster.pop('success', 'Admin Panel', 'Builder database has been updated');
    //         $scope.selectedBuilder = response;
    //     }, function(error) {
    //         toaster.pop('error', 'Admin Panel', error.data);
    //     });
    // };

    $scope.updateBuilder = function() {
        $scope.selectedBuilder.$update(function(response) {
            toaster.pop('success', 'Company Admin Panel', 'Builder database has been updated');
        }, function(error) {
            toaster.pop('error', 'Company Admin Panel', error);
        });
    };

    // $scope.addDivision = function() {
    //     $scope.selectedBuilder.division.push({
    //         name: '',
    //         address_one: '',
    //         address_two: '',
    //         city: '',
    //         state: '',
    //         zip: '',
    //         phone: '',
    //         email: '',
    //         builders: []
    //     });
    // };

    // $scope.removeDivision = function(idx) {
    //     $scope.selectedBuilder.division.splice(idx,1);
    // };

    // $scope.addBuilderUser = function(index) {
    //     $scope.selectedBuilder.division[index].builders.push('');
    //     console.log('adding builder');
    // };

    // $scope.removeBuilderUser = function(index, idx) {
    //     $scope.selectedBuilder.division[index].builders.splice(idx,1);
    //     console.log('removing division');
    // };

    $scope.states = [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
    ];

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/builderAdminCompany.js